import posthog from "posthog-js";

import { sanitizePostHogLogRecord } from "@/lib/posthog-log-sanitize";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST;

const LOG_LEVEL_RANK = {
	debug: 1,
	error: 4,
	fatal: 5,
	info: 2,
	trace: 0,
	warn: 3,
} as const;

const MIN_CAPTURED_LOG_LEVEL: keyof typeof LOG_LEVEL_RANK = "warn";

const shouldCaptureLogLevel = (level: string | undefined) => {
	const rank = LOG_LEVEL_RANK[level as keyof typeof LOG_LEVEL_RANK];
	return rank !== undefined && rank >= LOG_LEVEL_RANK[MIN_CAPTURED_LOG_LEVEL];
};

if (!POSTHOG_KEY || !POSTHOG_HOST) {
	if (import.meta.env.DEV && import.meta.env.MODE !== "test") {
		console.warn(
			`VITE_POSTHOG_${POSTHOG_KEY ? "HOST" : "KEY"} is missing or un-configured. PostHog will not initialize, so analytics events will be silently missed. This warning stops appearing once VITE_POSTHOG_${POSTHOG_KEY ? "HOST" : "KEY"} is configured.`,
		);
	}
} else if (import.meta.env.MODE !== "test") {
	posthog.init(POSTHOG_KEY, {
		api_host: POSTHOG_HOST,
		autocapture: {
			dom_event_allowlist: ["click"],
			element_allowlist: ["a", "button"],
		},
		capture_exceptions: {
			capture_console_errors: false,
			capture_unhandled_errors: true,
			capture_unhandled_rejections: true,
		},
		defaults: "2026-05-30",
		logs: {
			beforeSend: (record) => {
				if (!shouldCaptureLogLevel(record.level)) {
					return null;
				}

				return sanitizePostHogLogRecord(record);
			},
			captureConsoleLogs: true,
		},
	});
}

export default posthog;
